// @flow
import type {Action} from '../../../state/types'

export type SetLocationPayload = {
  location: ?Location,
}

const id = 'map/SET_LOCATION'

export const setLocation = (location: ?Location): Action<SetLocationPayload> => ({
  type: id,
  payload: {
    location,
  }
})

setLocation.id = id
